import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from "react-redux";
import store from "./redux";

import { CustomThemeProvider } from './components/ThemeContext/CustomThemeProvider';
import { WebSocketProvider } from './components/WebSocketContext/WebSocketContext';

// O react-virtuoso dispara "ResizeObserver loop ..." — um aviso BENIGNO do browser
// (a medição de tamanho não coube em um frame; não quebra nada). O overlay de erro
// do react-scripts o trata como fatal e cobre a tela. Silenciamos só esse caso.
const RESIZE_OBSERVER_ERR = /ResizeObserver loop/;
window.addEventListener('error', (e) => {
  if (e?.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.style.display = 'none';
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <WebSocketProvider>
        <CustomThemeProvider>
          <App />
        </CustomThemeProvider>
      </WebSocketProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
